import { FluentBuilder } from '../types/fluent-builder.type';

export const createBuilder = <T>(initialData: Partial<T>, build: (data: Partial<T>) => T): FluentBuilder<T> => {
  class ImmutableBuilder implements FluentBuilder<T> {
    constructor(public readonly data: Partial<T>) {}

    with(data: Partial<T>): ImmutableBuilder {
      return new ImmutableBuilder({ ...this.data, ...data });
    }

    build() {
      return build(this.data);
    }
  }

  return new ImmutableBuilder(initialData);
};
